<template>
  <div class="NavIndex">
    <div class="menu_all flex">
      <div
        class="drap_down flex"
        @mouseleave="outList"
        @mouseenter="showHidList = true"
      >
        <!-- <i class="nav_icon"></i> -->
        <SvgIcon
          color="#000000"
          size="20px"
          name="icon-chouti"
        ></SvgIcon>
        <span class="hidden-title">{{ channelName }}{{ TLang('分类','common') }}</span>
        <div
          v-show="showHidList"
          class="hid-list"
        >
          <ul :class="{ hid_list_scroll: catList && catList.length > 10 }">
            <li
              v-for="item in catList"
              :key="item.id"
              :class="{ 'drap_down-item': true,
                        active: item.id === activeId
              }"
              @mouseenter="hoverItem(item)"
              @click="
                onChange(item.id,item,1);
                showHidList = false;
              "
            >
              <img
                :src="item.imgUrl"
                alt
              />
              <span>{{ item.name }}</span>
              <i class="icon iconfont">&#xe657;</i>
            </li>
          </ul>
          <div
            v-if="activeItem.subCategoryList && activeItem.subCategoryList.length"
            class="subListCont"
            :style="{ height: catList.length * 44 + 'px' }"
          >
            <p
              @click="
                onChange(activeId,activeItem,1);
                showHidList = false;
              "
            >
              {{ activeTitle }}
            </p>
            <div class="sub-list">
              <div
                v-for="goods in activeItem.subCategoryList"
                :key="goods.id"
                class="sub3-item"
                @click="
                  onChange(goods.id,goods,2);
                  showHidList = false;
                "
              >
                {{ goods.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { unionFlag } from '@utils';
export default {
  name: 'NavIndex',
  props: {
    catList: Array,
    channelName: String,
    onChange: Function,
  },
  data() {
    return {
      cateList: [],
      activeTitle: '',
      activeId: null,
      showHidList: false,
      activeItem: {},
      union: unionFlag(),
    };
  },
  methods: {
    hoverItem(item) {
      this.cateList = [];
      if (item.name && item.id) {
        this.activeTitle = item.name;
        this.activeId = item.id;
        this.activeItem = item;
      }
    },
    outList() {
      // this.activeTitle = '';
      // this.activeId = null;
    },
  },
};
</script>

<style scoped lang="less">
.NavIndex {
  display: flex;
  background: #fff;
  height: 44px;
  .menu_all {
    width: 220px;
    background: #fafafa;
    border:1px solid #f0f0f0;
    background-size: 100% auto;
    font-size: 16px;
    color: #000000;
    text-align: center;
    line-height: 44px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .drap_down {
      position: relative;
      // width: 100%;
      // min-width: 200px;
      justify-content: left;
      box-sizing: border-box;
      .nav_icon{
        width: 16px;
        height: 14px;
        margin-right: 10px;
        background: url('../../../../JDLife/LeftNavList/navIcon.png') center center no-repeat;
        background-size: 100% auto;
        margin-left: 52px;
      }
      .hidden-title{
        margin-left: 10px;
      }
      .hid-list {
        position: absolute;
        top: 100%;
        width: 100%;
        background: #fff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
        z-index: 999;
        transition: all ease 800ms;
        max-height: 440px;
        display: none;
        .hid_list_scroll{
          width: 100%;
          max-height: 440px;
          overflow: hidden;
          overflow-y: scroll;
        }
        li.drap_down-item {
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          display: flex;
          padding-left: 15px;
          padding-right: 10px;
          align-items: center;
          position: relative;
          white-space: nowrap;
          img {
            width: 24px;
            height: 24px;
            vertical-align: middle;
          }
          i {
            transform: rotate(90deg);
            margin-left: auto;
            font-size: 20px;
          }
          span {
            margin-left: 12px;
          }
          &::after {
            content: "";
            display: inline-block;
            height: 1px;
            width: 100%;
            background: #f7f7f7;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        li.drap_down-item:hover {
          cursor: pointer;
          &::after {
            background: rgba(63, 166, 255, 0.1);
            background: var(--df-primary-color-opacity);
          }
        }
        li.active {
          background: rgba(63, 166, 255, 0.1);
          background: var(--df-primary-color-opacity);
          cursor: pointer;
          color:#3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
          &::after {
            background: rgba(63, 166, 255, 0.1);
            background: var(--df-primary-color-opacity);
          }
          span{
            font-weight: bold;
          }
        }
        .subListCont {
          position: absolute;
          left: 100%;
          top: 0;
          background: #fff;
          color: #000;
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
          width: 680px;
          padding: 30px;
          box-sizing: border-box;
          max-height: 440px;
          overflow-y: scroll;
          p {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            text-align: left;
            position: relative;
            &:after {
              content: "";
              display: inline-block;
              width: 630px;
              height: 1px;
              background: #f0f0f0;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }
          .sub-list {
            display: flex;
            flex-wrap: wrap;
            font-size: 12px;
            color: rgba(51, 51, 51, 1);
            max-height: 300px;
            overflow-y: scroll;
            .sub3-item {
              margin-right: 20px;
            }
            .sub3-item:hover {
              font-size: 12px;
              font-weight: bold;
              color:#3FA6FF;
              color: var(--df-primary-color, #3FA6FF);
              cursor: pointer;
            }
          }
        }
      }
    }
    .drap_down:hover {
      cursor: pointer;
    }
    .drap_down:hover .hid-list {
      display: block;
    }
  }
}
</style>
